import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { API_URL as API } from '../config/api';

const AuthContext = createContext();

// Helper to get token from localStorage
const getStoredToken = () => localStorage.getItem('session_token');
const setStoredToken = (token) => {
  if (token) {
    localStorage.setItem('session_token', token);
  } else {
    localStorage.removeItem('session_token');
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const token = getStoredToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true,
        headers
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
      setStoredToken(null); // Clear invalid token
    } finally {
      setLoading(false);
    }
  };

  const login = async (userData) => {
    // Store user data and token
    setUser(userData);
    if (userData.token) {
      setStoredToken(userData.token);
    }
  };

  const logout = async () => {
    try {
      const token = getStoredToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      await axios.post(`${API}/auth/logout`, {}, {
        withCredentials: true,
        headers
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setUser(null);
      setStoredToken(null);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, checkAuth, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);